import { useEffect, useMemo, useState } from "react";
import { breakpoints } from "styles";

const useMediaQuery = (deviceType: "mobile" | "tablet" | "laptop"): boolean => {
  const query = breakpoints[deviceType];
  const mediaQuery = useMemo(
    () => (typeof window !== "undefined" ? window.matchMedia(query) : null),
    [query]
  );
  const [match, setMatch] = useState(!!mediaQuery?.matches);

  useEffect(() => {
    if (!mediaQuery) return;
    setMatch(mediaQuery.matches);
    const handler = (e: MediaQueryListEvent) => setMatch(e.matches);
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, [mediaQuery]);

  return match;
};

export { useMediaQuery };
